import React from "react";
import { Box, Typography } from "@mui/material";
import HorizontalLine from "../../../../../components/divider";

const MainBoxStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const NetworkDetailSection = ({ fields }) => {

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#EAF0F7",
        borderRadius: "5px",
        padding: { xs: "1.5rem 1rem", md: "1.5rem 1.2rem" },
        marginTop: { xs: ".8rem", md: "0" },
      }}
    >
      <Box>
        {fields.map((field, index) => (
          <React.Fragment key={index}>
            {/* If it's a section title */}
            {/* {field.type === "section" ? (
              
              <Typography variant="h1" sx={{ m: { xs: "1rem 0", sm: " .7rem 0rem 1rem" } }}>
                {field.label}
              </Typography>
            ) : ( */}
            <>
              <Box sx={MainBoxStyle}>
                <Typography variant="h4">{field.label}:</Typography>
                <Typography variant="subtitle2">
                  {" "}
                  {field.value || "-"}
                </Typography>
              </Box>

              {index !== fields.length - 1 && <HorizontalLine />}
            </>
            {/* )} */}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default NetworkDetailSection;
